var isEmptyString = function isEmptyString(str) {
  // name only contains whitespace (ie. spaces, tabs or line breaks
  if (str) {
    return !str.replace(/\s/g, '').length;
  }
  return true;
};
var containsSpecialCharacters = function containsSpecialCharacters(str) {
  // check if string contains characters other than ASCII punctuation, symbols, digits, or latin alphabet
  var charCode;
  if (str) {
    for (var i = 0; i < str.length; i += 1) {
      charCode = str.charCodeAt(i);
      if (charCode < 32 || charCode > 126 && charCode < 160 || charCode > 255) {
        return true;
      }
    }
  }
  return false;
};

export { containsSpecialCharacters, isEmptyString };
//# sourceMappingURL=index.es.js.map
